<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols='12' md='4'>
          <basics v-if='project' :project='project' @update='update'></basics>
        </v-col>
        <v-col cols='12' md='4'>
          <snow-details v-if='project' :project='project' @update='update'></snow-details>
        </v-col>
        <v-col cols='12' md='4'>
          <driveway-rating v-if='project' :project='project' @update='update'></driveway-rating>
        </v-col>
        <v-col cols='12' md='4'>
          <contacts v-if='project' :project='project' @update='update'></contacts>
        </v-col>
        <v-col cols='12' md='4'>
          <customer-notes v-if='project' :project='project' @update='update'></customer-notes>
        </v-col>
        <v-col cols='12' md='4'>
          <field-instructions v-if='project' :project='project' @update='update'></field-instructions>
        </v-col>
        <v-col cols='12' md='4'>
          <sales-notes v-if='project' :project='project' @update='update'></sales-notes>
        </v-col>
        <v-col cols='12' md='4'>
          <invoicing-notes v-if='project' :project='project' @update='update'></invoicing-notes>
        </v-col>
        <v-col cols='12' md='4'>
          <quote-total v-if='project' :obj='project' title='Season Pricing'></quote-total>
        </v-col>
        <v-col cols='12' md='12'>
          <project-files v-if='project' :files='project.project_file_data' :project_id='project.id'
            :disabled='project.archived'></project-files>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Basics from '@/modules/projects/components/Basics';
import Contacts from '@/modules/projects/components/Contacts';
import Details from '@/modules/snow/components/Details';
import DrivewayRating from '@/modules/snow/components/DrivewayRating';
import QuoteTotal from '@/modules/estimates/components/snow/QuoteTotal';
import FieldInstructions from '@/modules/projects/components/FieldInstructions';
import CustomerNotes from '@/modules/projects/components/CustomerNotes';
import InvoicingNotes from '@/modules/projects/components/InvoicingNotes';
import SalesNotes from '@/modules/snow/components/SalesNotes';
import ProjectFiles from '@/components/files/ProjectFiles';

export default {
  name: 'snow-overview',
  props: {
    project: {
      required: true
    }
  },
  methods: {
    update(proj) {
      this.$emit('update', proj)
    }
  },
  components: {
    'basics': Basics,
    'contacts': Contacts,
    'snow-details': Details,
    'field-instructions': FieldInstructions,
    'driveway-rating': DrivewayRating,
    'customer-notes': CustomerNotes,
    'invoicing-notes': InvoicingNotes,
    'sales-notes': SalesNotes,
    'quote-total': QuoteTotal,
    'project-files': ProjectFiles
  }
}

</script>
